import { render, staticRenderFns } from "./ChatAtendimento.vue?vue&type=template&id=c409c494&scoped=true"
import script from "./ChatAtendimento.vue?vue&type=script&lang=js"
export * from "./ChatAtendimento.vue?vue&type=script&lang=js"
import style0 from "./ChatAtendimento.vue?vue&type=style&index=0&id=c409c494&prod&lang=css"
import style1 from "./ChatAtendimento.vue?vue&type=style&index=1&id=c409c494&prod&lang=scss"
import style2 from "./ChatAtendimento.vue?vue&type=style&index=2&id=c409c494&prod&scoped=true&lang=css"
import style3 from "./ChatAtendimento.vue?vue&type=style&index=3&id=c409c494&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c409c494",
  null
  
)

export default component.exports